import { authenticatedFetch } from '../../common/api';
import { getTheme } from '../../common/pageData';
import { getURLWithParamsFromArray } from '../../common/util';
import { getURLWithBasicParams } from '../../components/request';
import { FETCH_WIDGET_DATA_API } from './constants';

export const fetchOfferData = async () => {
  const { theme_store_id, name } = getTheme();

  const params = [
    {
      key: 'themeStoreID',
      value: theme_store_id,
    },
    {
      key: 'themeName',
      value: name,
    },
  ];
  const data = await authenticatedFetch({
    api: `${getURLWithParamsFromArray(`${getURLWithBasicParams(`${FETCH_WIDGET_DATA_API}?`, false)}&`, params, false)}`,
  });
  // uncomment this when testing. '.header__icons' creates a new div under buttons. this one places it correctly
  // data.display.position = 'before';
  // data.display.selector = '.header__search';
  return data;
};
